import React from "react";
import styles from '../styles/exchangeContent.module.scss'
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useTranslation } from "react-i18next";
import Icon from "@/wmCompoments/Icon";
import classNames from "classnames";

const ExchangeContent = ({ exchangeType, balanceData, onSwitch }) => {
  const { t } = useTranslation('walletExchange')

  // 判断是否从中心钱包兑换(方向)
  const isFromCenter = exchangeType === 0;
  // 左右钱包标题
  const firstTitle = isFromCenter ? `${t('from')} ${t('centralWallet')}` : `${t('from')} ${t('cryptoWallet')}`;
  const secondTitle = isFromCenter ? `${t('to')} ${t('cryptoWallet')}` : `${t('to')} ${t('centralWallet')}`;
  // 左右钱包余额
  const firstBalance = isFromCenter ? balanceData?.centerWalletBalance : balanceData?.usdtWalletBalance;
  const secondBalance = isFromCenter ? balanceData?.usdtWalletBalance : balanceData?.centerWalletBalance;

  const firstIcon = isFromCenter ? <Icon name="icon-mine-wallet" className={styles.wallet_icon} /> : <Icon name="icon-usdt" className={styles.wallet_icon} />
  const secondIcon = isFromCenter ? <Icon name="icon-usdt" className={styles.wallet_icon} /> : <Icon name="icon-mine-wallet" className={styles.wallet_icon} />

  return (
    <div className={styles.exchangeContent}>
      {/* 左侧钱包信息 */}
      <div className={styles.content}>
        {firstIcon}
        <div className={styles.text}>
          <div className={styles.wallet}>{firstTitle}</div>
          <div className={styles.balance}>{firstBalance}</div>
        </div>
      </div>

      {/* 中间切换按钮 */}
      <div onClick={onSwitch} className={styles.switch}> 
        <Icon name="icon-wallet-exchange" className={styles.icon} />
      </div>

      {/* 右侧钱包信息 */}
      <div className={styles.content}>
        {secondIcon}
        <div className={styles.text}>
          <div className={styles.wallet}>{secondTitle}</div>
          <div className={styles.balance}>{secondBalance}</div>
        </div>
      </div>
    </div>
  )
}

export default ExchangeContent